module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image5c"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "331",
      "src": "images/8.jpg",
      "width": "300"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Opening your first bank account as an adult is a big deal. Banks have restrictions on the access minors have to their money. But as soon as you turn eighteen, you’re on your own. So here are some banking basics you need to know.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Types of financial institutions")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Commercial banks deal mainly with business and industry.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Savings banks serve individuals.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Savings-and-loan institutions concentrate on providing home mortgages.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Credit unions were established to provide emergency loans, but they also offer checking and savings accounts as well as many other banking services. However, membership may not be open to everyone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("At one time these various institutions provided separate services, but today they offer many of the same ones. So it’s best to shop around for the financial firm that serves you best.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "h3"
  }, [_vm._v("Types of accounts")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Savings account")]), _vm._v(": This is where you place the money you want to set aside so it can earn a higher interest rate. Normally, no fees are charged to withdraw funds, but this is not where you’ll want to put the money you use in the course of everyday living.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Checking account")]), _vm._v(": This is where you put the money you need to live off of every month. You can make withdrawals from this account via check, ATM, debit card, or electronic transfer. Usually little or no interest is earned on this account. Some banks charge fees for various aspects of this service. You will also have to pay for your own checks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("NOW (Negotiable Order of Withdrawal) account")]), _vm._v(": This is a checking account that earns interest but also requires you to maintain a minimum balance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Money market deposit account")]), _vm._v(": This is a savings account, though it offers some services you’d find with a checking account. Funds kept in this kind of account earn interest at a higher rate than a typical savings account, but you may have more transaction restrictions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Certificates of Deposit (CDs)")]), _vm._v(": Investment savings accounts that “lock in” your funds at a set interest rate for a fixed period of time, such as six months or a couple of years. Penalties are assessed for early withdrawal. This is where you would keep money that you want to save, not spend.")])]), _c('p', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Questions to ask when comparing banks")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Is there a monthly fee for the account?")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Does the account earn interest? If so, how much?")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Is there a fee for ATM transactions?")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Is there a limit on how many withdrawals you can make per month?")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Does the account come with a debit card?")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Can you use your debit card as a credit card?")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Does the debit card earn you any rewards, like cash back or airline miles?")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Does the institution offer online banking? Is there a fee?")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Can you pay bills online? Does it cost anything to do that?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-721179a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch05.vue
// module id = 99
// module chunks = 0